export const GET_SETTING_COIN = 'GET_SETTING_COIN';
export const GET_SETTING_COIN_SUCCESS = 'GET_SETTING_COIN_SUCCESS';
export const GET_SETTING_COIN_FAILED = 'GET_SETTING_COIN_FAILED';

export const UPDATE_SETTING_COIN = 'UPDATE_SETTING_COIN';
export const UPDATE_SETTING_COIN_SUCCESS = 'UPDATE_SETTING_COIN_SUCCESS';
export const UPDATE_SETTING_COIN_FAILED = 'UPDATE_SETTING_COIN_FAILED';

export const GET_HISTORY_COIN = 'GET_HISTORY_COIN';
export const GET_HISTORY_COIN_SUCCESS = 'GET_HISTORY_COIN_SUCCESS';
export const GET_HISTORY_COIN_FAILED = 'GET_HISTORY_COIN_FAILED';
